import { render, staticRenderFns } from "./OnlyCompany.vue?vue&type=template&id=0303ab10&"
import script from "./OnlyCompany.vue?vue&type=script&lang=js&"
export * from "./OnlyCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports